import { z } from 'zod';

const venueCompsFormSchema = z.object({
  venueComps: z.string(),
});

type VenueCompsFormSchemaType = typeof venueCompsFormSchema;
export type VenueCompsFormDataType = z.infer<VenueCompsFormSchemaType>;

type UseVenueCompsFormSchemaReturnType = {
  schema: VenueCompsFormSchemaType;
  defaultValues: VenueCompsFormDataType;
};

export const useVenueCompsFormSchema = (
  venueComps: string | null
): UseVenueCompsFormSchemaReturnType => {
  const defaultValues: VenueCompsFormDataType = {
    venueComps: venueComps ?? '',
  };

  return { schema: venueCompsFormSchema, defaultValues };
};
